import { store } from "redux/store";

//api
import api from "api/api";

//classes
import Flight from "./flight";
import Slot from "./slot";
import Aircraft from "./aircraft";
import Route from "./route";
import axios from "axios";

class FlightPlan {
	#id;
	constructor(_options = {}) {
		this.#id = _options.id;
		this.name = _options.name || "";
		this.flights = _options.flights || [];
	}

	get id() {
		return this.#id;
	}

	get savedInRedux() {
		return this.#id != null;
	}

	setName(name) {
		this.name = name;
		return this;
	}

	includesFlight(destination) {
		console.warn("Not implemented!!!", destination);
		return true;
		// return this.flights.reduce(
		// 	(includes, flight) => includes || Slot.get(flight.slotId).destination === destination,
		// 	false
		// );
	}

	clearFlights() {
		console.warn("Not implemented!!!");
		// this.flights = [];
		// this.update();
		return this;
	}

	/**
	 * A method used to get the distance of the longest flight.
	 * @return {number} Distance of the longest route in the flight plan.
	 */
	getMaxRange() {
		console.warn("Not implemented!!!");
		return 0;
		// return this.flights.reduce(
		// 	(biggestValue, flight) => (flight.distance > biggestValue ? flight.distance : biggestValue),
		// 	0
		// );
	}

	/**
	 * A method that creates new instance of FlightPlan, preserving the flights.
	 * @return {FlightPlan | null} The new instance on success or null on failure.
	 */
	createInstanceOf() {
		const newFlightPlan = new FlightPlan();
		const flights = this.toObject().flights.map((flight, i) => {
			const destination = Slot.get(flight.slotId).destination;
			const [slotToUse] = Slot.getByDestination(destination);
			if (!slotToUse) return null;

			const newFlight = new Flight(
				newFlightPlan.id,
				slotToUse.id,
				flight.origin,
				null,
				this.getColorForFlight(),
				i + 1
			);
			return newFlight;
		});

		if (flights.includes(null)) return null;
		return FlightPlan.fromObject({ flights });
	}

	getColorForFlight() {
		const colors = ["#794F92", "#EB5C68", "#F9DD62", "#4994FD", "#00B8A2", "#6CAE32"];
		const usedColors = this.flights.map(f => f.color);
		const filteredColors = colors.filter(c => !usedColors.includes(c));
		return filteredColors[0] || null;
	}

	/**
	 * A method that returns the next flight from the flight plan.
	 * @param {String} currentFlight A UUID of the current flight.
	 * @param {Aircraft} aircraft Currently assigned aircraft
	 * @return {Array<String, Number>} [New route UUID, New flight id].
	 */
	async getNextFlight(currentFlightId, aircraft) {
		if (this.flights.length === 0) return [null, null];

		const currFl = Flight.get(currentFlightId);
		if (this.flights.length === 1) return [aircraft.route, currentFlightId];

		const route = Route.get(aircraft.route);
		route.removeAircraft(aircraft.ident);

		const currSeq = currFl.sequence;
		const nextSeq = currSeq + 1 > this.flights.length ? 1 : currSeq + 1;
		const nextFlight = Flight.getBySequence(this.flights, nextSeq);
		const nextSlot = Slot.get(nextFlight.slotId);
		const nextRoute = Route.new(nextFlight.origin, nextSlot.destination);
		await nextRoute.addAircraft(aircraft.ident);
		return [nextRoute.id, nextFlight.id];
	}

	deleteFlight(id) {
		this.flights = this.flights.filter(f => f.id !== id);
	}

	prepareForEdit() {
		console.warn("Not implemented!!!");

		// const aircraft = Aircraft.get(this.aircraft);
		// const currFlIndex = this.flights.findIndex(f => f.id === aircraft.currentFlight);

		// this.flights = this.flights.slice(currFlIndex).concat(this.flights.slice(0, currFlIndex));
		// this.setSavedInRedux(false);

		return this;
	}

	/**
	 * Returns an aircraft assigned to a flight plan
	 * @return {Aircraft}
	 */
	getAssignedAircraft() {
		const fleet = [...store.getState().fleet.values()];
		const [aircraft] = fleet.filter(a => a.assignedFlightPlan === this.id);
		return aircraft;
	}

	get assignedAircraft() {
		return this.getAssignedAircraft();
	}

	hasAssignedAircraft() {
		const fleet = [...store.getState().fleet.values()];
		const ids = fleet.map(a => a.assignedFlightPlan);
		return ids.includes(this.id);
	}

	getFlights() {
		const allFlights = store.getState().flights;
		return allFlights.filter(f => this.flights.includes(f.id));
	}

	/**
	 * Deletes the flight plan (redux & db).
	 * @param {boolean} confirmation Sets if the confirmation message should be displayed. Defaults to true.
	 * @return {boolean} True if successfully deleted, otherwise false.
	 * @async
	 */
	async delete(confirmation = true) {
		const lang = store.getState().lang;

		if (confirmation) {
			const confirmationMsg =
				lang === "PL"
					? `Czy jesteś pewny/a, że chcesz usunąć plan lotu o nazwie "${this.name}"?`
					: `Are you sure you want to delete a flight plan named "${this.name}"?`;
			if (!window.confirm(confirmationMsg)) return false;
		}

		if (!(await this.unassignAircraft())) return false;

		try {
			await axios.delete(`${api}/flightPlan/${this.id}`);
			store.dispatch({ type: "DELETE_FLIGHTS", flightIds: this.flights });
			store.dispatch({ type: "DELETE_FLIGHT_PLAN", flightPlanId: this.#id });

			return true;
		} catch (error) {
			console.error(error);
			alert(lang === "PL" ? "Coś poszło nie tak" : "Something went wrong");
			return false;
		}
	}

	/**
	 * A method that unassigns an aircraft from a flight plan.
	 * @param {Boolean} force Determines if aircraft location should be taken into the account. Defaults to false.
	 * @return {boolean} True if successful, otherwise false.
	 * @async
	 */
	async unassignAircraft(force = false) {
		const assignedAircraft = this.getAssignedAircraft();

		if (!assignedAircraft) return true;
		if (!force && !assignedAircraft.planCanBeChanged()) {
			return false;
		}

		try {
			const { data, status } = await axios.patch(`${api}/flightPlan/${this.id}/unassignAircraft`, { force });
			if (status === 204) {
				alert("Coś poszło nie tak!");
				return false;
			}

			const aircraft = Aircraft.get(data) || assignedAircraft;
			aircraft.assignedFlightPlan = null;
			aircraft.currentFlight = null;
			aircraft.status = "parked";

			Route.get(aircraft.route)?.removeAircraft(aircraft.ident);
			aircraft.route = null;

			aircraft.updateInRedux();
			document.dispatchEvent(new CustomEvent("updateAircraftIcon", { detail: { aircraftIdent: aircraft.ident } }));
			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	//* Static methods
	/**
	 * A static method that gets a flight plan with provided id
	 * @param {string} id plan uuid.
	 * @return {FlightPlan | undefined} Returns the flight plan or undefined.
	 */
	static get(id) {
		const allFlightPlans = store.getState().flightPlans;
		return allFlightPlans.find(plan => plan.id === id);
	}

	/**
	 * A static method. Returns a flightplan containing a flight with provided id.
	 * @param {number} flightId flight id.
	 * @return {FlightPlan | undefined} Returns the flight plan.
	 */
	static getByFlightId(flightId) {
		const allFlightPlans = store.getState().flightPlans;
		return allFlightPlans.find(plan => plan.flights.includes(flightId));
	}

	/**
	 * A static method that checks if selected aircraft is already assigned to any flight plan.
	 * @static
	 */
	static isAircraftAssigned(aircraftIdent) {
		//! Probably doesn't work
		const allFlightPlans = store.getState().flightPlans;
		return allFlightPlans.reduce((flag, plan) => (flag ? flag : plan.aircraft === aircraftIdent), false);
	}

	//* Object conversion methods
	/**
	 * A static method used to convert an object to a FlightPlan
	 * @param {Object} obj The object to convert
	 * @static
	 */
	static fromObject(obj) {
		// if (obj.flights) obj.flights = obj.flights.map(f => Flight.fromObject(f));
		return new FlightPlan(obj);
	}

	/**
	 * A method used to convert a class instance into an object. Also outputs private properties!
	 * @return {Object} A class instance converted to an object
	 */
	toObject() {
		const keys = Object.getOwnPropertyNames(Object.getPrototypeOf(this));

		let instanceAsObject = keys.reduce((classAsObj, key) => {
			classAsObj[key] = this[key];
			return classAsObj;
		}, {});

		instanceAsObject = Object.keys(this).reduce((classAsObj, key) => {
			classAsObj[key] = this[key];
			return classAsObj;
		}, instanceAsObject);

		delete instanceAsObject.toObject;
		delete instanceAsObject.constructor;
		delete instanceAsObject.savedInRedux;
		delete instanceAsObject.assignAircraft;
		delete instanceAsObject.includesFlight;

		delete instanceAsObject.setName;
		delete instanceAsObject.addFlight;
		delete instanceAsObject.removeFlight;
		delete instanceAsObject.clearFlights;
		delete instanceAsObject.assignAircraft;
		delete instanceAsObject.getMaxRange;
		delete instanceAsObject.save;
		delete instanceAsObject.update;
		delete instanceAsObject.delete;
		return instanceAsObject;
	}
}

export default FlightPlan;
export { FlightPlan as flightPlan };
